import { gql } from '@apollo/client';

export const GET_ENSENANZA_ID = gql`
  {
    getEnsenanzaId @client
  }
`;

export const GET_ENSENANZA = gql`
  query getEnsenanza($id: ID!) {
    getEnsenanza(id: $id) {
      _id
      tipo
      resumen
      contenido
    }
  }
`;

export const GET_ENSENANZAS = gql`
  query getEnsenanzas($paginate: getEnsenanzasPaginate!) {
    getEnsenanzas(paginate: $paginate) {
      ensenanzas {
        node {
          _id
          tipo
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_ENSENANZAS = gql`
  query searchEnsenanzas($paginate: searchEnsenanzasPaginate!) {
    searchEnsenanzas(paginate: $paginate) {
      cuentos {
        node {
          _id
          tipo
          resumen
          contenido
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_ENSENANZA = gql`
  mutation createEnsenanza($input: CreateEnsenanzaInput!) {
    createEnsenanza(input: $input) {
      _id
      tipo
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const UPDATE_ENSENANZA = gql`
  mutation updateEnsenanza($input: UpdateEnsenanzaInput) {
    updateEnsenanza(input: $input) {
      _id
      tipo
      resumen
      contenido
      code
      success
      message
    }
  }
`;

export const REMOVE_ENSENANZA = gql`
  mutation removeEnsenanza($input: DeleteEnsenanzaInput!) {
    removeEnsenanza(input: $input) {
      code
      success
      message
    }
  }
`;
